module.exports = __webpack_public_path__ + "static/Riadul_Hoque_Resume_2021-40af334a4936c0528aed76101ddaf1a6.pdf";